export const STEP_ROUTE_MAP: { [key: string]: string } = {
  step1: "organisatie",
  step2: "mobiliteit",
  step3: "beleid",
  step4: "controle-automatisering",
  step5: "gebruikersbeheer",
  step6: "sso",
  step7: "budgettering",
};
